import Api from '@/api/api.js'

export default{

    saveAntecedentsPerso(data,patientId){
        const promise = Api().put('/dossiers_medicaux/save/'+patientId+'/antecedents_personnels',data)
        return promise.then((response) => response.data)

    },

    getPatientAntecedentPerso(patientId){
        const promise = Api().get('/dossiers_medicaux/patient/'+patientId+'/antecedents_personnels')
        return promise.then((response) => response.data)
    },

    getConsultationAntecedent(data){   // TODO: Delete 
        const promise = Api().post('/consultations/list/antecedents', data)
        return promise.then((response) => response.data)
    },

    getConsultationAnamneses(data){
        const promise = Api().post('/consultations/list/antecedents', data)
        return promise.then((response) => response.data)
    },

    getPatientAntecedent(data){
        const promise = Api().get('/consultations/patient/'+data.patient_id+'/type_antecedent/'+data.data_type+'/antecedents')
        return promise.then((response) => response.data)
    },

    saveConsultationAntecedent(data){
        const promise = Api().post('/consultations/antecedents/store', data)
        return promise.then((response) => response.data)
    },

    savePatientAntecedent(data){
        const promise = Api().post('/consultations/patient_antecedents/store', data)
        return promise.then((response) => response.data)
    },

    deleteAntecedent(data){
        const promise = Api().post('/consultations/delete/antecedents', data)
        return promise.then((response) => response.data)
    },
}